module.exports = __webpack_public_path__ + "img/sample_globe_document_order.006cebee.svg";